import Layout from '@/layout'

const route = {
  path: '/report',
  component: Layout,
  redirect: '/report/index',
  alwaysShow: true, // will always show the root menu
  name: 'report',
  meta: {
    title: '小说',
    icon: 'novel',
    roles: [
      'novel_management'
    ]
  },
  children: [
    {
      path: '/channelReport/index',
      name: 'channelReport',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '渠道报表',
        roles: [
          'channel.report.new'
        ]
      },
      children: [
        {
          path: '/channelGroupList/index',
          component: () => import('@/views/report/channelGroupList.vue'),
          name: 'channelGroupList',
          meta: {
            title: '快应用-渠道组报表',
            icon: 'component',
            roles: [
              'report_form.predit.channel_form_group'
            ]
          }
        }, {
          path: '/channel/index',
          component: () => import('@/views/report/channel.vue'),
          name: 'SevenChannelReport',
          meta: {
            title: '快应用-渠道报表',
            icon: 'component',
            roles: [
              'novel_management.channel.list'
            ]
          }
        },
        {
          path: '/report/channelList/index',
          component: () => import('@/views/report/channelList.vue'),
          name: 'SevenChannelList',
          meta: {
            title: '快应用-渠道列表',
            icon: 'component',
            roles: [
              'novel_management.channel.index'
            ]
          }
        },
        {
          path: '/report/generalChannelReport/index',
          component: () => import('@/views/report/generalChannelReport.vue'),
          name: 'generalChannelReport',
          meta: {
            title: '快应用-渠道总报表',
            icon: 'component',
            roles: [
              'novel_management.channel.index'
            ]
          }
        },
        {
          path: '/report/channelTotalReport/index',
          component: () => import('@/views/report/channelTotalReport.vue'),
          name: 'channelTotalReport',
          meta: {
            title: '快应用-渠道总计报表',
            icon: 'component',
            roles: [
              'novel_management.channel.index'
            ]
          }
        },
        {
          path: '/miniprogramforms/index',
          component: () => import('@/views/report/miniprogramforms.vue'),
          name: 'SevenChannelReport',
          meta: {
            title: '小程序-渠道报表',
            icon: 'component',
            roles: [
              'novel_management.channel.list'
            ]
          }
        },
        {
          path: '/miniprogramlist/index',
          component: () => import('@/views/report/miniprogramlist.vue'),
          name: 'SevenChannelReport',
          meta: {
            title: '小程序-渠道列表',
            icon: 'component',
            roles: [
              'novel_management.channel.list'
            ]
          }
        },
        {
          path: '/novelMiniprogramforms/index',
          component: () => import('@/views/report/novelMiniprogramforms.vue'),
          name: 'SevenChannelReport',
          meta: {
            title: '小说小程序-推广报表',
            icon: 'component',
            roles: [
              'novel_management.channel.list'
            ]
          }
        },
        {
          path: '/novelMiniprogramlist/index',
          component: () => import('@/views/report/novelMiniprogramlist.vue'),
          name: 'SevenChannelReport',
          meta: {
            title: '小说小程序-推广列表',
            icon: 'component',
            roles: [
              'novel_management.channel.list'
            ]
          }
        }
      ]
    },
    {
      path: '/exportRecord/index',
      name: 'exportRecord',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '导出记录',
        roles: [
          'export.openid.new'
        ]
      },
      children: [
        {
          path: '/report/exportLog/index',
          component: () => import('@/views/report/exportLog/index.vue'),
          name: 'ExportLog',
          meta: {
            title: '导出记录',
            icon: 'component',
            roles: [
              'export_task.index' // 已修改权限
            ]
          }
        },
        {
          path: '/openID/index',
          component: () => import('@/views/report/openID.vue'),
          name: 'openID',
          meta: {
            title: 'openID',
            icon: 'component',
            roles: [
              'novel_report_selects.index'
            ]
          }
        }]
    },

    // 公众号列表
    {
      path: '/listOfOfficialAccount/index',
      name: 'listOfOfficialAccount',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '公众号列表',
        roles: [
          'wechat_accounts.index'
        ]
      },
      children: [
        {
          path: '/report/officialAccountStatement',
          component() {
            return import('@/views/report/officialAccountStatement.vue')
          },
          name: 'officialAccountStatement',
          meta: {
            title: '公众号报表',
            roles: [
              'wechat_form_groups.index'
            ]
          }

        },
        {
          path: '/report/reportAccount',
          component() {
            return import('@/views/report/reportAccount.vue')
          },
          name: 'PublicGroupReport',
          meta: {
            title: '公众号组报表',
            roles: [
              'common.wechat_account_list'
            ]
          }
        },
        // {
        //   path: '/report/rechargeReport',
        //   component: () => import('@/views/report/rechargeReport.vue'),
        //   name: 'rechargeReport',
        //   meta: {
        //     title: '公众号-累充报表',
        //     icon: 'component',
        //     roles: [
        //       'report_form.predit.recharge_report'
        //     ]
        //   }
        // },
        {
          path: '/report/accountManagement',
          component: () => import('@/views/report/accountManagement.vue'),
          name: 'AccountManagement',
          meta: {
            title: '公众号管理',
            icon: 'component',
            roles: [
              'wechat_accounts.index'
            ]
          }
        },
        {
          path: '/report/wechatUsers',
          component: () => import('@/views/report/wechatUsers.vue'),
          name: 'WechatUsers',
          meta: {
            title: '公众号-管理员列表',
            icon: 'component',
            roles: [
              'wechat_users.index'
            ]
          }
        },
        {
          path: '/report/wechatGroup',
          component() {
            return import('@/views/report/wechatGroup.vue')
          },
          name: 'PublicAdvertiserList',
          meta: {
            title: '公众号-广告主列表',
            roles: [
              'wechat_advertisers.index'
            ]
          }
        }]
    },
    // 小说报表
    {
      path: '/report/index',
      component: () => import('@/views/report/index.vue'),
      name: 'NovalReportTab',
      meta: {
        title: '小说报表',
        icon: 'component',
        roles: [
          'novel_report_selects.index'
        ]
      }
    },
    // 小说列表
    {
      path: '/report/novalList',
      component: () => import('@/views/report/novalList.vue'),
      name: 'NovalList',
      meta: {
        title: '小说列表',
        icon: 'component',
        roles: [
          'novels.index'
        ]
      }
    }
    // 小说昨日统计
    // {
    //   path: '/report/beforeNoval',
    //   component: () => import('@/views/report/beforeNoval.vue'),
    //   name: 'BeforeNoval',
    //   meta: {
    //     title: '小说昨日统计',
    //     icon: 'component',
    //     roles: [
    //       'novels.index'
    //     ]
    //   }
    // }
    // {
    //   path: '/report/tencent',
    //   component: () => import('@/views/report/tencent.vue'),
    //   name: 'report',
    //   meta: {
    //     title: '小说管理',
    //     icon: 'component',
    //     roles: [
    //       'novel_report_selects.index'
    //     ]
    //   }
    // },
    // {
    //   path: '/report/appId',
    //   component: () => import('@/views/report/appId.vue'),
    //   name: 'report',
    //   meta: {
    //     title: '小说分配',
    //     icon: 'component',
    //     roles: [
    //       'larke-admin.extension.index'
    //     ]
    //   }
    // },
    // {
    //   path: '/report/accountOfficial',
    //   component() {
    //     return import('@/views/report/accountOfficial.vue')
    //   },
    //   meta: {
    //     title: '公众号组绑定',
    //     roles: [
    //       'novel_management.msrelation'
    //     ]
    //   }
    // },
  ]
}

export default route
